import React from 'react';
import PropTypes from 'prop-types';

import FichesFirst from '../../blocks/FichesFirst';
import FichesActionsTypes from '../../blocks/FichesActionsTypes';
import FichesActionsTransversales from '../../blocks/FichesActionsTransversales';
import FichesRetourExperience from '../../blocks/FichesRetourExperience';
import Footer from '../../blocks/Footer';
import ScrollTop from '../../components/ScrollTop';
// import BackHome from '../../components/BackHome';

class FichesPage extends React.Component {
  render() {
    const { data } = this.props;
    return (
      <>
        <FichesFirst data={data} />
        <FichesActionsTypes data={data} />
        <FichesActionsTransversales data={data} />
        <FichesRetourExperience data={data} />
        <Footer data={data} />
        <ScrollTop />
        {/* <BackHome /> */}
      </>
    );
  }
}

FichesPage.propTypes = {
  data: PropTypes.object.isRequired,
};

export default FichesPage;
